




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ModelLibService } from '@/api/com/MetaPattern/APP/MDA/ModelLib/ModelLibService';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';

class UseAPPInfo {
  sourceAPPId: string;
  workScopeId: string;
  aPPKey: string;
  gitUrl: string;
  gitUsername: string;
  gitPassword: string;
  gitBranchName: string;
}

@Component({
  components: {
  }
})
export default class UseAPP extends Vue {
  @Prop() sourceAPPId!: string; // 应用ID
  private app: APP; // 应用
  private appDisplayName: string;
  private useAPPInfo: UseAPPInfo = null;
  private workscopes: Array<any>;

  constructor() {
    super();
    this.useAPPInfo = new UseAPPInfo();
    this.useAPPInfo.sourceAPPId = this.sourceAPPId;
    this.workscopes = new Array<any>();
    this.appDisplayName = '';
  }

  mounted() {
    ModelLibService.GetAPPInfoAsync(this.sourceAPPId)
      .then(app => {
        this.app = app;
        this.appDisplayName = this.app.displayName;
        this.useAPPInfo.aPPKey = app.aPPKey;
      });
  }

  cancel() {
    (this.$refs.useAPPInfo as any).resetFields();
    this.$emit('closeDialog', null);
  }

  confirm() {
    (this.$refs.useAPPInfo as any).validate((valid: any) => {
      if (valid) {
        const loadingText = '正在努力执行，这个操作需要几分钟，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const workscope = this.getWorkScopes().find((item: WorkScope) => item.id === this.useAPPInfo.workScopeId) as WorkScope;
        this.useAPPInfo.aPPKey = `${workscope.name}_${this.app.aPPKey}`;
        ModelLibService.UseAPPAsync(this.useAPPInfo.sourceAPPId, this.useAPPInfo.workScopeId, this.useAPPInfo.aPPKey, this.useAPPInfo.gitUrl, this.useAPPInfo.gitBranchName, this.useAPPInfo.gitUsername, this.useAPPInfo.gitPassword)
          .then((item: APP) => {
            // TODO: 加入到应用树里面，应用面板里面
            this.$message({ type: 'success', message: '操作成功，请前往应用面板查看!' });
            loading.close();
            this.$emit('closeDialog', this.useAPPInfo);
          })
          .catch(error => {
            console.log(error);
            this.$message({ type: 'error', message: '操作失败!原因是：' + error });
            loading.close();
          });
      } else {
        return false;
      }
    });
  }

  getWorkScopes() {
    return this.$store.state.ModuleMD.workScopes;
  }

  get labelWidth() {
    return '120px';
  }
}

